import { BreakpointMenuCombinedProps } from './types';

const usePresenter = (props: BreakpointMenuCombinedProps): BreakpointMenuCombinedProps => {
  return props;
};

export default usePresenter;
